module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("There are many people who contributed to making this book possible. We would like to thank Wesley Davey, Alex Oakley, and Tara Dew for their labor in helping us read and edit the manuscript. We also thank two anonymous reviewers for many helpful suggestions and substantive comments—the book is better for their efforts. We are grateful for the work of David McNutt for overseeing our book and being a pleasure to work with. The staff at IVP was a model of grace and efficiency. Finally, we would like to thank our wives and children for their love and support all along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex",
      "title": "x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f9db5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_acknowledgments.vue
// module id = 66
// module chunks = 0